var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-container"},[_c('v-progress-linear',{class:_vm.loading ? 'progress' : 'progress noshow',attrs:{"color":"grey","indeterminate":""}}),_vm._t("default"),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"overlay"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }